<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex class="d-flex justify-space-between mb-3 align-center" xs12>
        <h3 class="font-weight-bold">Revenue Office Wise Report</h3>
        <div class="text-xs-right">
          <export-summary-report-button model="revenue-officewise" :export-date="range" :export-office="office"
                                        v-if="$oauth.checkIfHasPermission(['export revenue-summary-report'])"/>
          <refresh-button :click-function="updateByOffice"></refresh-button>
        </div>
      </v-flex>
      <v-flex xs12>

        <v-card>
          <v-layout class="py-1 mx-2" row wrap>
            <v-flex xs6 class="d-flex align-center">
              <custom-date-range-picker @change="updateByOffice"
                                        v-model="range"/>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete
                  :items="offices"
                  chips
                  clearable
                  deletable-chips
                  flat
                  hide-details
                  item-text="name"
                  item-value="id"
                  label="Office"
                  multiple
                  prepend-inner-icon="filter_list"
                  solo
                  v-model="office"
                  @change="updateByOffice"
              />
            </v-flex>
          </v-layout>

          <v-divider/>
          <v-card-text class="pa-0">
            <v-simple-table
                class="elevation-0 pb-6"
                v-if="$oauth.checkIfHasPermission(['read revenue-summary-report'])"
            >
              <thead>
              <!--              <v-progress-linear-->
              <!--                  :active="progressLinearLoading"-->
              <!--                  :indeterminate="progressLinearLoading"-->
              <!--                  absolute-->
              <!--                  bottom-->
              <!--                  color="primary"-->
              <!--              ></v-progress-linear>-->
              <v-overlay :value="progressLinearLoading">
                <v-progress-circular
                    indeterminate
                    size="64"
                ></v-progress-circular>
              </v-overlay>
              <tr>
                <th class="text-center">S.N</th>
                <th>Office Name</th>
                <th class="text-center">Online(USD)</th>
                <th class="text-center">Online(NPR)</th>
                <th class="text-center">Ma.Le.Ni.Ka(USD)</th>
                <th class="text-center">Ma.Le.Ni.Ka(NPR)</th>
                <th class="text-center">Manual(USD)</th>
                <th class="text-center">Manual(NPR)</th>
                <th class="text-center">Total(USD)</th>
                <th class="text-center">Total(NPR)</th>
              </tr>
              </thead>
              <tbody v-if="office_wise_data">
              <tr v-for="(item,i) in office_wise_data">
                <td class="text-center">{{ i + 1 }}</td>
                <td>{{ item.office_name }}</td>
                <td class="text-center">{{ item.online }}</td>
                <td class="text-center">{{ item.online_npr }}</td>
                <td class="text-center">{{ item.malenika }}</td>
                <td class="text-center">{{ item.malenika_npr }}</td>
                <td class="text-center">{{ item.manual }}</td>
                <td class="text-center">{{ item.manual_npr }}</td>
                <td class="font-weight-bold text-center">{{ item.total }}</td>
                <td class="font-weight-bold text-center">{{ item.total_npr }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td class="text-center" colspan="2">Total</td>
                <td class="text-center">{{ total_data.total_online }}</td>
                <td class="text-center">{{ total_data.total_online_npr }}</td>
                <td class="text-center">{{ total_data.total_malenika }}</td>
                <td class="text-center">{{ total_data.total_malenika_npr }}</td>
                <td class="text-center">{{ total_data.total_manual }}</td>
                <td class="text-center">{{ total_data.total_manual_npr }}</td>
                <td class="text-center">{{ total_data.total_total_amount }}</td>
                <td class="text-center">{{ total_data.total_total_amount_npr }}</td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td><h3 class="text-center">No record found</h3></td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import CustomDateRangePicker from "../../components/CustomDateRangePicker";
import {commonStoreMixin} from "../../mixins/commonStoreMixin";
import IssuedVisaFooter from "../../components/footer/IssuedVisaFooter";
import ExportSummaryReportButton from "../../components/ExportSummaryReportButton";
import ExportButton from "../../components/ExportButton";
import Http from "axios";
import {VERSIONED_API_URL} from "../../config/config";
import RefreshButton from "@/components/RefreshButton";

const REVENUE_SUMMARY_REPORT_URL = `${VERSIONED_API_URL}/summary-report/revenue-officewise`;

export default {
  name: "RevenueOfficeWise",
  data() {
    return {
      office_wise_data: [],
      office:[],
      range: {},
      exchange_rate: null,
    };
  },
  components: {RefreshButton, CustomDateRangePicker, IssuedVisaFooter, ExportSummaryReportButton},
  mixins: [commonStoreMixin],
  computed: {
    ...mapGetters({
      loading: "ArrivalDepartureReport/reportLoading",
    }),
    from_main_office() {
      return this.$store.state.AuthUser.user.from_main_office;
    },
    offices() {
      return this.$store.state.OfficeList.offices;
    },
    total_data() {
      let total_online = 0
      let total_online_npr = 0
      let total_malenika = 0
      let total_malenika_npr = 0
      let total_manual = 0
      let total_manual_npr = 0
      let total_total_amount = 0
      let total_total_amount_npr = 0
      this.office_wise_data.forEach(item => {
        total_online += item.online ? parseFloat(item.online) : 0
        total_online_npr += item.online_npr ? parseFloat(item.online_npr) : 0
        total_malenika += item.malenika ? parseFloat(item.malenika) : 0
        total_malenika_npr += item.malenika_npr ? parseFloat(item.malenika_npr) : 0
        total_manual += item.manual ? parseFloat(item.manual) : 0
        total_manual_npr += item.manual_npr ? parseFloat(item.manual_npr) : 0
        total_total_amount += item.total ? parseFloat(item.total) : 0
        total_total_amount_npr += item.total_npr ? parseFloat(item.total_npr) : 0
      })
      return {
        total_online,
        total_online_npr,
        total_malenika,
        total_malenika_npr,
        total_manual,
        total_manual_npr,
        total_total_amount,
        total_total_amount_npr
      }
    }
  },
  methods: {
    ...mapActions({fetchOffices:'OfficeList/fetchAll'}),
    arrivedReport(item) {
      let params = {fromAD: true, type: 'Arrival', country: item.country};
      this.$router.push({
        name: 'ArrivalDepartureReport',
        params: params
      });

    },
    departedReport(item) {
    },
    updateByOffice() {
      let params = {};
      this.progressLinearLoading = true;
      if (Object.keys(this.range).length > 0)
        params.date_range = this.range;
      if (this.office)
        params.office = this.office;
      Http.get(REVENUE_SUMMARY_REPORT_URL, {
        params: params
      })
          .then((res) => {
            this.office_wise_data = res.data.data;
            this.progressLinearLoading = false;
            // this.getData();
          })
          .catch(() => {
            this.$store.commit('Notification/showError', 'Something went wrong');
            this.progressLinearLoading = false;
          });
    }


  },
  mounted() {
    this.progressLinearLoading = true;
    this.fetchOffices();
    Http.get(REVENUE_SUMMARY_REPORT_URL)
        .then((res) => {
          this.office_wise_data = res.data.data;
          this.exchange_rate = res.data.exchange_rate
          this.progressLinearLoading = false;
        })
        .catch(() => {
          this.progressLinearLoading = false;
        });

    this.range = {
      start: new Date().toISOString().substr(0, 10),
      end: new Date().toISOString().substr(0, 10)
    }
  }
}
</script>
